<template>
  <container>
    <router-view></router-view>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * User layout
 * ==================================================================================
 **/
import MainLayout from '@/layouts/MainLayout.vue'

export default {
  components: {
    container: MainLayout
  }
}
</script>
